document.addEventListener('DOMContentLoaded', function() {
	let printButtons = document.querySelectorAll('.js-print-recipe');
  if (printButtons.length) {
    printButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        let printContents = '';
        let recipeBanner = document.querySelector('.section-recipeBanner');
        let recipeContainer = document.querySelector('.recipe');
        
        if (recipeBanner) {
          printContents += recipeBanner.outerHTML;
        }
        
        if (recipeContainer) {
          printContents += recipeContainer.outerHTML;
        }
        
        let originalContents = document.body.innerHTML;
        let originalStyles = document.head.innerHTML;
        
        document.body.innerHTML = printContents;
        document.head.innerHTML += '<link rel="stylesheet" type="text/css" href="/path/to/your/print.css">';
        
        window.print();
        
        document.body.innerHTML = originalContents;
        document.head.innerHTML = originalStyles;
        location.reload();
      });
    });
  }
});